import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx, Fragment } from 'react/jsx-runtime';
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import React__default from 'react';
import ComposedWidgetLink from './components/link.mjs';

var PureDynamicWidgetRenderer = function PureDynamicWidgetRenderer(_ref) {
  var content = _ref.content,
    redirectCallback = _ref.redirectCallback,
    onDomClick = _ref.onDomClick;
  var _React$useState = React__default.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    parsedContent = _React$useState2[0],
    setParsedContent = _React$useState2[1];
  var handleClick = React__default.useCallback(function (e) {
    onDomClick === null || onDomClick === void 0 ? void 0 : onDomClick(e);
  }, []);
  var option = React__default.useMemo(function () {
    return {
      replace: function replace(domNode) {
        var _a;
        if (domNode.name === "a") {
          var optProps = attributesToProps(domNode.attribs);
          return /*#__PURE__*/React__default.createElement(ComposedWidgetLink, Object.assign(Object.assign({}, optProps), {
            redirectCallback: redirectCallback
          }), domToReact(domNode.children));
        }
        if ((_a = domNode.attribs) === null || _a === void 0 ? void 0 : _a["data-ev"]) {
          var _optProps = attributesToProps(domNode.attribs);
          _optProps.onClick = handleClick;
          return /*#__PURE__*/React__default.createElement(domNode.name, _optProps, domToReact(domNode.children, option));
        }
        return domNode;
      }
    };
  }, []);
  React__default.useEffect(function () {
    if (!content) return;
    setParsedContent(parse(content, option));
  }, [content]);
  return jsx(Fragment, {
    children: parsedContent
  });
};
var DynamicWidgetRenderer = /*#__PURE__*/React__default.memo(PureDynamicWidgetRenderer);

export { DynamicWidgetRenderer, PureDynamicWidgetRenderer };
